'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.defaultProps = exports.propTypes = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = exports.propTypes = {
	first: _propTypes2.default.bool,
	children: _propTypes2.default.node.isRequired,
	onHeaderClick: _propTypes2.default.func,
	index: _propTypes2.default.number,
	right: _propTypes2.default.bool,
	tooltip: _propTypes2.default.string,
	sort: _propTypes2.default.oneOf(['asc', 'dsc'])
};

var defaultProps = exports.defaultProps = {
	first: false,
	index: 0,
	right: false,
	tooltip: '',
	sort: null
};


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMTableHeaderCell/propTypes.js